<mat-card>
  <h2 translate>sidenav.menu.registerPapyments</h2>

  <mat-card-content>
    <form [formGroup]="registerPayment" (ngSubmit)="onSendClick()">
      <div fxFlex fxLayout="row wrap" style="width: 100%" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!isExternalCommercial">
          <scf-custom-select-search
            #chainSelect
            [id]="'chain'"
            formControlName="chain"
            fxFlex="100"
            [dataInput]="chainsList"
            [placeholder]="'monthlyReport.selectChain'"
            [isMultiple]="false"
            [showErrors]="registerPayment?.controls?.chainsList?.errors"
            (selectionChange)="onChainSelection($event)"
          >
          </scf-custom-select-search>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!isExternalCommercial">
          <scf-custom-select-search
            [id]="'prescriptor'"
            formControlName="prescriptor"
            fxFlex="100"
            [dataInput]="prescriptorsList"
            [placeholder]="'tracingReports.selectPrescriptor'"
            [isMultiple]="false"
            [isRequired]="true"
            [showErrors]="registerPayment?.controls?.prescriptor?.errors"
            (selectionChange)="onPrescriberSelection($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'establishment'"
            formControlName="establishment"
            fxFlex="100"
            [dataInput]="establishmentsList"
            [placeholder]="'tracingReports.selectEstablishment'"
            [isRequired]="true"
            [isMultiple]="false"
            [showErrors]="registerPayment?.controls?.establishment?.errors"
            (selectionChange)="onEstablishmentSelection($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="60" fxFlex.gt-sm="25">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>paymentCert.amount</mat-label>
            <input
              id="priceRequested"
              matInput
              #amountRequested
              formControlName="amountRequested"
              type="text"
              maxlength="21"
              (blur)="transformAmount($event, amountRequested)"
              (keypress)="numberOnly($event, amountRequested)"
              (paste)="numberOnly($event, amountRequested)"
              autocomplete="off"
            />
            <mat-error *ngIf="registerPayment.controls.amountRequested.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error
              *ngIf="
                registerPayment.controls.amountRequested.errors?.maxValue ||
                registerPayment.controls.amountRequested.errors?.minValue
              "
              translate
            >
              paymentCert.amountNotAllowed
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="60" fxFlex.gt-sm="25">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>paymentCert.sol</mat-label>
            <input
              id="contractId"
              matInput
              #numSol
              formControlName="numSol"
              type="text"
              maxlength="15"
              (keypress)="numberOnly($event, numSol)"
              (paste)="numberOnly($event, numSol)"
              autocomplete="off"
            />
            <mat-error *ngIf="registerPayment.controls.numSol.errors?.required" translate> field.required </mat-error>
            <mat-error *ngIf="registerPayment.controls.numSol.errors?.numSolInvalid" translate>
              paymentCert.invalidSol
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" class="titleDoc" *ngIf="isEnableFile">
          <div class="docIndication">
            <span>{{ 'paymentCert.adjDoc' | translate }}</span>
          </div>
          <div>
            <span>{{ 'request.update.formats' | translate }}</span>
            <span>{{ 'uploadDocuments.filesAllowed' | translate }}</span>
          </div>
          <div>
            <span>{{ 'request.update.weight.long' | translate }}</span>
          </div>
        </div>
        <div fxFlex="100">
          <scf-drag-drop-update
            [limitOfFiles]="LimitOfFiles"
            [reset]="resetFile"
            [isEnabled]="isEnableFile"
            (saveFiles)="setFilesToUpload($event)"
          ></scf-drag-drop-update>
        </div>
        <div fxFlex="99">
          <div fxFlexAlign="start" fxLayoutAlign="end">
            <button
              id="searchTracingReports"
              mat-flat-button
              type="submit"
              color="accent"
              [disabled]="registerPayment.invalid || this.fileToSend.length === 0"
            >
              <span>{{ 'request.buttonSend' | translate | uppercase }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
